import {  useState } from "react"

export const useModal = () => {
    const [showModal,setShowModal] = useState(false)
    const handleToggleModal = () => setShowModal(!showModal)

    return {
        showModal,handleToggleModal
    }
}